import axios from 'axios'
import apiClient from '@/services/apiClient'

/**
 * Führt den kompletten Login-Prozess durch
 * @param {string} username - Benutzername
 * @param {string} password - Passwort
 * @param {Object} store - Vuex Store Instanz
 * @returns {Promise<void>}
 */
export async function performLogin(username, password, store) {
  console.log('Login gestartet für:', username)

  // Demo-User Flag setzen
  if (username === 'demo@example.com' && password === 'demo123') {
    localStorage.setItem('isDemoUser', true)
  } else {
    localStorage.setItem('isDemoUser', false)
  }

  // Token zurücksetzen
  axios.defaults.headers.common["Authorization"] = ""
  localStorage.removeItem("token")

  const formData = {
    username: username,
    password: password,
  }

  // Login durchführen
  const response_login = await apiClient.post("/api/v1/token/login/", formData)
  const token = response_login.data.auth_token

  store.commit('setToken', token)
  axios.defaults.headers.common["Authorization"] = "Token " + token
  localStorage.setItem("token", token)

  // User-Daten laden
  const response_me = await apiClient.get("/api/v1/users/me/")
  store.commit('setUser', {
    'username': response_me.data.username,
    'id': response_me.data.id
  })
  localStorage.setItem('username', response_me.data.username)
  localStorage.setItem('userid', response_me.data.id)
  store.commit('setMe', response_me.data)

  // Optional: User Alert anzeigen
  if (response_me.data.user_alert_text) {
    const modalElement = document.getElementById('modalOpenAlert')
    if (modalElement) {
      modalElement.click()
    }
  }

  // Dashboard laden
  const response_dashboard = await apiClient.get("/api/v1/dashboard/")
  store.commit('setPlants', response_dashboard.data)

  // Authgroup laden
  const response_authgroup = await apiClient.get("/api/v1/authgroup/")
  store.commit('setPermissions', response_authgroup.data[0])
  store.commit('setIsAuthenticated', true)

  // Organisation laden
  const organisationID = store.state.me.organisation
  const response_orga = await apiClient.get(`/api/v1/organisations/${organisationID}/`)
  store.commit('setOrganisation', response_orga.data)

  console.log('Login erfolgreich abgeschlossen')
}

/**
 * Führt den Demo-Login durch
 * @param {Object} store - Vuex Store Instanz
 * @returns {Promise<void>}
 */
export async function performDemoLogin(store) {
  return performLogin('demo@example.com', 'demo123', store)
}
